"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_tracker_1 = require("@snowplow/browser-tracker");
const entities_1 = require("../../dataStructures/entities");
/**
 * Sets global contexts for the Snowplow Tracker
 *
 * @param globalContextsConfiguration any user set configuration options
 */
const setGlobalContexts = (presetGlobalContexts = {}, additionalGlobalContexts) => {
    if ((additionalGlobalContexts === null || additionalGlobalContexts === void 0 ? void 0 : additionalGlobalContexts.additionalGlobalContexts) !== undefined) {
        (0, browser_tracker_1.addGlobalContexts)(additionalGlobalContexts.additionalGlobalContexts);
    }
    const { brandName } = presetGlobalContexts;
    if (brandName !== undefined) {
        const brandAttributes = (0, entities_1.brandAttributesContext)(brandName);
        if (brandAttributes !== undefined) {
            (0, browser_tracker_1.addGlobalContexts)([brandAttributes]);
        }
    }
};
exports.default = setGlobalContexts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZ2xvYmFsQ29udGV4dC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLCtEQUE4RDtBQUs5RCw0REFBdUU7QUFFdkU7Ozs7R0FJRztBQUNILE1BQU0saUJBQWlCLEdBQUcsQ0FDdEIsdUJBQXlELEVBQUUsRUFDM0Qsd0JBQStELEVBQzNELEVBQUU7SUFDTixJQUFJLENBQUEsd0JBQXdCLGFBQXhCLHdCQUF3Qix1QkFBeEIsd0JBQXdCLENBQUUsd0JBQXdCLE1BQUssU0FBUyxFQUFFO1FBQ2xFLElBQUEsbUNBQWlCLEVBQUMsd0JBQXdCLENBQUMsd0JBQXdCLENBQUMsQ0FBQztLQUN4RTtJQUVELE1BQU0sRUFBRSxTQUFTLEVBQUUsR0FBRyxvQkFBb0IsQ0FBQztJQUUzQyxJQUFJLFNBQVMsS0FBSyxTQUFTLEVBQUU7UUFDekIsTUFBTSxlQUFlLEdBQUcsSUFBQSxpQ0FBc0IsRUFBQyxTQUFTLENBQUMsQ0FBQztRQUUxRCxJQUFJLGVBQWUsS0FBSyxTQUFTLEVBQUU7WUFDL0IsSUFBQSxtQ0FBaUIsRUFBQyxDQUFDLGVBQWUsQ0FBQyxDQUFDLENBQUM7U0FDeEM7S0FDSjtBQUNMLENBQUMsQ0FBQztBQUVGLGtCQUFlLGlCQUFpQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/utils/globalContext/index.ts